export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.params.tech === 'null') {
    return navigateTo('/')
  }

  const tech = useTech()

  // If navigating from a tech-prefixed route to a non-tech route,
  // clear any team selection and its cookie to avoid leaking context.
  const fromTech = tech.detectTechRaw(from?.path, from?.params)
  const toTech = tech.detectTechRaw(to.path, to.params)

  if (!toTech && fromTech) {
    tech.clear()
  }

  try {
    await tech?.detectTech(to.path, to.params)
  } catch (e) {
    console.error('Error detecting tech:', e)
    if (to.path === '/') {
      throw createError({
        statusCode: 500,
        statusMessage: 'Something went wrong, Please reload the page.',
        data: 'reload'
      })
    } else {
      return navigateTo('/')
    }
  }

  // Apply beta test logic to all tech paths
  if (to.params.tech && to.fullPath.startsWith(`/${to.params.tech}/` && tech?.data?.status === 'COMING_SOON')) {
    const betaTest = useCookie('beta', false)

    if (!betaTest.value && to.path !== `/${to.params.tech}/success`) {
      throw createError({ statusCode: 404, statusMessage: 'Page is under construction.' })
    }
  }
})
